import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        order: {
          ...store.getState().i18n.translations.en.common.order,
          factSheet: {
            SAMPLE_REPORT: 'Sample report',
            PREVIEW_FACT_SHEET_DESC: `FiinGate Factsheet is an autogenerated report providing necessary data about a company (Company profile, Ownership & Group, Financial Data, Score, Industry), allowing you to quickly assess and make decision. You can choose all or one of these data blocks.
            <br/>By dowloading the FiinGate Factsheet, you will receive the report including chosen data blocks in pdf format together with an excel Financial Statement (if any).`,
            PREVIEW_FACT_SHEET_DESC_2:
              'Save %{percent} with a trade discount when buying all data.',
            FIINGATE_FACTSHEET: 'FiinGate Factsheet',
            SERVICE_DETAIL: 'Service details',
            POPUP_FACT_SHEET_DESC: `FiinGate Factsheet is an autogenerated report providing necessary data about a company (Company Profile, Ownership & Group, Financial Data, Score, Industry), allowing you to quickly assess and make decision.
            <br/>By dowloading the FiinGate Factsheet, you will receive the report in pdf format together with an excel Financial Statement.
            <br/>Currently, FiinGate Factsheet is only available for Corporations, Banks and Securities Firms.`,
            FOOTER_NOTE: `You can select between different presentations
              of this Company's Financial Statements in the %{link}
              tab. Financial data in this report is generated according to your selection.`,
            NOTE: 'Note:',
            LINK: 'Financial Statement',
            SCORE_REPORTING_DATE: '(Last updated date: %{year})',
            FS_SETTINGS: 'Financial Statements Settings',
            CONSOLIDATED: 'Consolidated',
            UNCONSOLIDATED: 'Separate',
            AUDITED: 'Audited',
            UNAUDITED: 'Unaudited',
            DIRECT: 'Direct',
            INDIRECT: 'Indirect',
            BLOCK_COMPANY_TYPE:
              'This service is currently unavailable for this type of company.',
            AVAILABLE_DATA: 'Latest Available FS Data',
          },
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        order: {
          ...store.getState().i18n.translations.vi.common.order,
          factSheet: {
            SAMPLE_REPORT: 'Báo cáo mẫu',
            PREVIEW_FACT_SHEET_DESC: `FiinGate Factsheet là một báo cáo định dạng pdf, được tạo tự động cung cấp dữ liệu cần thiết về một công ty (Hồ sơ công ty, Quan hệ & Sở hữu, Dữ liệu tài chính, Điểm số, Ngành), cho phép bạn nhanh chóng đánh giá và đưa ra quyết định. Bạn có thể chọn tất cả hoặc một trong các khối dữ liệu này.
            <br/>Bạn sẽ nhận được báo cáo định dạng pdf gồm các gói dữ liệu đã chọn, kèm một bản Báo cáo tài chính định dạng excel (nếu có) khi tải FiinGate Factsheet.`,
            PREVIEW_FACT_SHEET_DESC_2:
              'Tiết kiệm %{percent} với CKTM khi mua toàn bộ gói dữ liệu.',
            FIINGATE_FACTSHEET: 'FiinGate Factsheet',
            SERVICE_DETAIL: 'Chi tiết dịch vụ',
            POPUP_FACT_SHEET_DESC: `FiinGate Factsheet là một báo cáo được tạo tự động cung cấp dữ liệu cần thiết về một công ty (Hồ sơ công ty, Quan hệ & Sở hữu, Dữ liệu tài chính, Điểm số, Ngành), cho phép bạn nhanh chóng đánh giá và đưa ra quyết định.
            <br/>Bạn sẽ nhận được báo cáo định dạng pdf kèm một bản Báo cáo tài chính định dạng excel khi tải FiinGate Factsheet.
            <br/>Hiện tại, FiinGate Factsheet chỉ áp dụng cho các loại hình Doanh nghiệp, Ngân hàng, Chứng khoán.`,
            FOOTER_NOTE: `Bạn có thể chọn xem các cách thể hiện Báo cáo tài chính khác
            nhau của Công ty này trong màn %{link}. Dữ liệu tài chính
            trong báo cáo này được tạo theo tùy chỉnh của bạn.`,
            NOTE: 'Lưu ý:',
            LINK: 'Báo Cáo Tài Chính',
            SCORE_REPORTING_DATE: '(Ngày cập nhật gần nhất: %{year})',
            FS_SETTINGS: 'Cài Đặt Báo Cáo Tài Chính',
            CONSOLIDATED: 'Hợp nhất',
            UNCONSOLIDATED: 'Riêng lẻ',
            AUDITED: 'Kiểm toán',
            UNAUDITED: 'Chưa kiểm toán',
            DIRECT: 'Trực tiếp',
            INDIRECT: 'Gián tiếp',
            BLOCK_COMPANY_TYPE:
              'Dịch vụ này chưa được phát triển cho loại hình doanh nghiệp đang xem.',
            AVAILABLE_DATA: 'Dữ Liệu BCTC Sẵn Có Gần Nhất',
          },
        },
      },
    },
  }),
)
